var path = '/Users/saulsoto/Documents/workspace/spa/spa-frontend/src/core/components/modal/modal.html';
var html = "<ng-transclude></ng-transclude>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/core/components/modal/modal.html
// module id = 815
// module chunks = 0